module.exports = __webpack_public_path__ + "img/c22.55e5c628.png";